module.exports = __webpack_public_path__ + "static/media/exclaimationBig.0a5a81eb.svg";